export function doScroll(id, isClose = false){
    if (isClose) {
        this.closeNav();
    }
    let app = document.querySelector('#app');
    let el = document.querySelector('#' + id);
    if (el !== null) {
        let offset = document.getElementById('navbar').offsetHeight;
        let rect = el.getBoundingClientRect();
        let scroll_offset = app.scrollTop + rect.top - offset;
        app.scrollTo(0, scroll_offset);
    } else {
        document.location='/?id='+id;
    }
}